import {officialPlugin} from '../../plugins';

/**
 * 拓扑插件-图形相关插件引用定义
 */


/**
 * 拓扑插件-定义常用插件引用
 * @type array 常用插件
 */
export const mainPluginArray = [
  // officialPlugin.initGrid(),
  // officialPlugin.initMinimap(),
  officialPlugin.initToolBar()
];
